import { AxiosResponse } from 'axios';

import { get, post } from 'services/api';

import { ILoginFormData } from 'views/LoginView/types';
import { IRegisterFormData } from 'views/RegisterView/types';
import { IChangePassword } from 'views/public/ChangePasswordView/types';
import { IForgotPasswordFormData } from 'views/public/ForgotPasswordView/types';

export const initialize = (): Promise<AxiosResponse> => get('auth/profile');

export const login = (formData: ILoginFormData): Promise<AxiosResponse> =>
  post('auth/login', formData);

export const loginPublic = (formData: ILoginFormData): Promise<AxiosResponse> =>
  post('auth/login-public', formData);

export const logout = (): Promise<AxiosResponse> => get('auth/logout');

export const registerPublic = (formData: IRegisterFormData): Promise<AxiosResponse> =>
  post('auth/register-public', formData);

export const resetPassword = (formData: IForgotPasswordFormData): Promise<AxiosResponse> =>
  post('users/resetPassword', formData);

export const changePassword = (formData: IChangePassword) => post('/users/passwordEmail', formData);
